<template>
    <!-- <div> -->
        <v-progress-linear
        v-if="cargando"
        :indeterminate="true"
        :color="configuracion.color"
      ></v-progress-linear>
    <!-- </div> -->
</template>
<script>
export default {
    data:()=>({
        cargando:false,
        configuracion:{
            color:'blue darken-1'
        }
    }),
    beforeDestroy() {
        Event.$off('mostrar');
        Event.$off('ocultar');
    },
    mounted() {
        this.$parent.$on('mostrar',(configuracion)=>{
            console.log('mostranto loader');
            this.configuracion = configuracion;
            this.cargando = true;
        });
        this.$parent.$on('ocultar',()=>{
            console.log('ocultando loader');
            this.configuracion = {
                color:'blue darken-1'
            };
            this.cargando = false;
        });
    },
}
</script>